<div class="policy-component" style="margin: 0 20px;">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>

    </div>

    <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
      <mat-select multiple [(ngModel)]="selectedDomains" (selectionChange)="filterPolicies()" placeholder="Domain Filter" style="min-width: 200px; margin-right: 40px;">
        <mat-option *ngFor="let domain of domains" [value]="domain">{{domain || '[Empty]'}}</mat-option>
      </mat-select>
      <mat-select multiple [(ngModel)]="selectedAreas" (selectionChange)="filterPolicies()" placeholder="Compliance Areas Filter" style="min-width: 200px; margin-right: 40px;">
        <mat-option *ngFor="let area of complianceAreas" [value]="area.complianceAreaId">{{area.name}}</mat-option>
      </mat-select>
      <button mat-raised-button
              (click)="add()"
              style="border-radius: 6px;margin-right: 10px; "
              class="button">
        Create
      </button>
      <button mat-raised-button
              (click)="inputFile.click()"
              style="border-radius: 6px;margin-right: 10px; "
              class="button">
        Import
      </button>
      <input #inputFile
             type="file"
             (change)="importPolicy($event)"
             [style.display]="'none'">

    </div>
  </div>
  <div style="display: flex; flex-direction: row; gap: 40px">
    <div style="height: calc(100vh - 240px); position: relative; flex: 1 1 auto; overflow: auto;">
      <i class="pi pi-server cursor-pointer"
         style="display: block; z-index: 10000; position: absolute; top: 10px; right: 10px;"
         (click)="displayProfile = !displayProfile"></i>
    <p-table [value]="policies" [(selection)]="selectedItems" *ngIf="policyForms"
               dataKey="id"
               (onRowReorder)="saveOrder($event)">
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th style="width:2em;"></th>
            <th style="width:2em;"></th>
            <th [pSortableColumn]="'name'">Policy or Procedure Name
              <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'modifiedDate'">Last Modified
              <p-sortIcon [field]="'modifiedDate'" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'isActive'">Active
              <p-sortIcon [field]="'isActive'" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'ownerName'">Policy Owner
              <p-sortIcon [field]="'ownerName'" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th *ngIf="isMaster">Default</th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-expanded="expanded" let-i="rowIndex">
          <tr [pReorderableRow]="i" *ngIf="!policyForms[i].hidden">
            <td>
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td style="width:2em;" [pRowToggler]="item">
              <span>
                <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
              </span>
            </td>
            <td [pRowToggler]="item">{{item.name}}</td>
            <td>{{item.modifiedDate | date: "shortDate"}}</td>
            <td>{{item.isActive ? "Active" : "Inactive"}}</td>
            <td>{{item.ownerName}}</td>
            <td *ngIf="isMaster">
              <mat-checkbox [checked]="settings && settings.defaultPolicies.indexOf(item.id) >= 0"
                            (change)="isDefaultUpdate(item, $event)"></mat-checkbox>
            </td>
            <td style="width: 5em;">
              <i class="pi pi-download" (click)="exportPolicy(item.id)"></i>
              <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Policy'"
                 [popoverMessage]="'You are going to delete this policy. Are you sure?'"
                 [appendToBody]="true"
                 [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                 (confirm)="dropPolicy(item)"></i></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-item let-i="rowIndex">
          <tr *ngIf="!policyForms[i].hidden">
            <td [attr.colspan]="isMaster ? 8 : 7">

              <form [formGroup]="policyForms[i]" style="width: 100%;">
                <mat-form-field style="width: 50%;">
                  <mat-label>Name</mat-label>
                  <input type="text" matInput name="name" formControlName="name" >
                </mat-form-field>
                <mat-form-field style="width: 20%; margin-left: 40px;">
                  <mat-label>Domain</mat-label>
                  <input type="text" matInput name="domain" formControlName="domain" >
                </mat-form-field>
                <div style="margin-top:20px; display: flex; flex-direction: row;">
                  <div style="flex:50%">
                    <mat-form-field>
                      <mat-label>Policy Owner</mat-label>
                      <mat-select formControlName="ownerId" >
                        <mat-option *ngFor="let user of users"
                                    [value]="user.userId">{{getFullName(user)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Authors</mat-label>
                      <mat-select
                                  formControlName="authorList"
                                  name="owners"
                                  multiple>
                        <mat-option *ngFor="let user of users" [value]="user">
                          {{getFullName(user)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Status</mat-label>
                      <mat-select
                                  formControlName="status"
                                  name="owners"
                      >
                        <mat-option [value]="'Drafting'">Drafting</mat-option>
                        <mat-option [value]="'Under Review'">Under Review</mat-option>
                        <mat-option [value]="'Final'">Final</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%">
                    Last modified by: {{getFullNameById(item.modifiedBy)}}
                  </div>
                  <div style="flex:25%">
                    Last
                    modified: {{item.modifiedDate | date : 'shortDate'}}  {{item.modifiedDate | date : 'shortTime'}}
                  </div>
                </div>
                <div style="display: flex; flex-direction: row;">
                  <div style="flex:25%">
                    <mat-form-field *ngIf="!policyForms[i].nameVisible">
                      <mat-label>Version</mat-label>
                      <mat-select formControlName="activeVersion"
                                  (selectionChange)="selectVersion($event, i)">
                        <mat-option *ngFor="let version of item.versions" [value]="version.id"><span
                          [style.font-weight]="version.parentId && version.parentId != version.Id ? 'normal' : 'bold'">{{version.versionName}}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="policyForms[i].nameVisible">
                      <mat-label>Version Name</mat-label>
                      <input type="text" matInput  formControlName="versionName"/>
                    </mat-form-field>
                    <i class="pi pi-pencil" *ngIf="!policyForms[i].nameVisible" (click)="editName(item, policyForms[i])"></i>
                    <i class="pi pi-cross" *ngIf="policyForms[i].nameVisible" (click)="cancelEditName(item, policyForms[i])"></i>
                  </div>
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>New Version Name</mat-label>
                      <input type="text" matInput  formControlName="newVersionName"/>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%; margin-left: 10px">
                    <button mat-button mat-raised-button style="margin: 10px 0 0 0"
                            [disabled]="!policyForms[i].value.parentId || policyForms[i].value.parentId == policyForms[i].value.Id"
                            (click)="setActive(i)">{{policyForms[i].value.parentId && policyForms[i].value.parentId != policyForms[i].value.Id ? "Make Active Version" : "Active Version"}}</button>
                  </div>
                  <div style="flex:25% margin-left: 10px">
                  </div>
                  <div style="flex:25%; margin-left: 10px">
                  </div>
                </div>
                <div>
                  <mat-form-field style="width: 100%">
                    <mat-label>Notes</mat-label>
                              <textarea matInput  formControlName="notes">
                              </textarea>
                  </mat-form-field>
                </div>
                <div style="display: flex; flex-direction: row;">
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Approval Owner</mat-label>
                      <mat-select formControlName="approvalOwnerId" >
                        <mat-option *ngFor="let user of users"
                                    [value]="user.userId">{{getFullName(user)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Frequency</mat-label>
                      <mat-select formControlName="frequency" >
                        <mat-option *ngFor="let item of recurringList"
                                    [value]="item.value">{{item.label}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Start Date</mat-label>
                      <input matInput
                             [matDatepicker]="picker"
                             formControlName="startDate"
                             name="rowDueDate">

                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <mat-checkbox formControlName="view">View</mat-checkbox>
                <button mat-button mat-raised-button style="margin: 10px 10px 10px 10px"
                        (click)="openReplace(i)">Replace</button>
                <ng-container  formArrayName="policySections">
                  <p-table [value]="policyForms[i].get('policySections').controls"
                           dataKey="policySectionId"
                           (onRowReorder)="saveSectionOrder(policyForms[i])"
                  >
                    <ng-template pTemplate="body" let-policySection let-expanded="expanded" let-j="rowIndex">
                      <tr [pReorderableRow]="j" [formGroupName]="j" (mouseover)="highlightedPolicySectionId = policySection.controls.policySectionId.value">
                        <td>
                          <div>
                            <div>
                              <span class="pi pi-bars" pReorderableRowHandle></span>
                              <span (click)="policySection.expanded = !policySection.expanded" style="cursor: pointer; margin-right: 10px;">
                                <i [ngClass]="policySection.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                              </span>
                              <mat-form-field style="width: 100px; margin-right: 10px;">
                                <mat-label>Main Section #</mat-label>
                                <input matInput  formControlName="number">
                              </mat-form-field>
                              <mat-form-field style="width: 400px; margin-right: 10px;">
                                <mat-label>Main Section Name</mat-label>
                                <input matInput  formControlName="title">
                              </mat-form-field>
                              <mat-form-field style="width: 100px; margin-left: 10px; margin-right: 10px;">
                                <mat-label>Sub-Section #</mat-label>
                                <input matInput  formControlName="subNumber">
                              </mat-form-field>
                              <mat-form-field style="width: 400px; margin-right: 10px;">
                                <mat-label>Sub-Section Name</mat-label>
                                <input matInput  formControlName="subTitle">
                              </mat-form-field>
                              <i class="pi pi-trash" (click)="deletePolicySection(policyForms[i], j)"></i>
                              <i class="pi pi-link ml-1" (click)="insertPolicySectionContent(policyForms[i], j)"></i>
                            </div>
                            <div *ngIf="policySection.expanded">
                            <div class="ql-editor" [ngStyle]="{'display': policyForms[i].controls.view.value ? 'block' : 'none'}"
                                 [innerHTML]="addToken(policySection.controls.text.value) | sanitizeHtml"></div>
                            <p-editor [ngStyle]="{'display': policyForms[i].controls.view.value ? 'none' : 'block'}"
                                      formControlName="text"
                                      type="text"
                            >

                              <p-header>
                              <span class="ql-formats">
                                <select class="ql-size">
                                  <option value="huge">Heading</option>
                                  <option value="large">Subheading</option>
                                  <option selected></option>
                                  <option value="small">Small</option>
                                </select>
                                <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                                  value="monospace">Monospace</option></select>
                              </span>
                                <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                                <button class="ql-strike" aria-label="Strike"></button>
                              </span>
                                <span class="ql-formats">
                                <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                                  value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                                  value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                                  value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                                  value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                                  value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                                  value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                                  value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                                  value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                                  value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                                  value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                                  value="#003700"></option><option value="#002966"></option><option
                                  value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                                <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                                  value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                                  value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                                  value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                                  value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                                  value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                                  value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                                  value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                                  value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                                  value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                                  value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                                  value="#003700"></option><option value="#002966"></option><option
                                  value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                            </span>
                                <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                  <option selected>Left</option>
                                  <option value="center" label="Center"></option>
                                  <option value="right" label="Right"></option>
                                  <option value="justify" label="Justify"></option>
                                </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                              </span>
                                <span class="ql-formats">
                                <button aria-label="Link" class="ql-link"></button>
                                <button aria-label="Document" style="font-size: 1.3em;margin-top: -3px;" #el
                                        (click)="selectDocument(el)">D</button>
                                <button aria-label="Image" class="ql-image"></button>
                                <button aria-label="Code block" class="ql-code-block"></button>
                              </span>
                                <span class="ql-formats">
                                <button aria-label="Clean" class="ql-clean"></button>
                              </span>
                                <!--span class="ql-formats">
                                  <button aria-label="" class="pi pi-table better-table"
                                          style="font-family: 'primeicons';"></button>
                                </span-->
                              </p-header>
                            </p-editor>
                            </div>
                            <div class="flex-row" style="margin-bottom: 20px;" *ngIf="policySection.expanded">
                              <div class="col-6">
                                <h6>Control Mapping:</h6>
                                <span *ngFor="let control of policySection.controls['controlIdList'].value">{{controlItemMap[control].complianceAreaName}} - {{controlItemMap[control].complianceAreaControlId}} <i class="pi pi-trash" (click)="removeControl(policySection.controls['controlIdList'], control)"></i></span>
                                <span class="pi pi-external-link" (click)="addControl(policySection.controls['controlIdList'])"></span>
                              </div>
                              <div class="col-6">
                                <h6>Directive Mapping:</h6>
                                <span *ngFor="let evidenceCentralItem of policySection.controls['evidenceCentralItems'].value">{{evidenceCentralItem.name}}<i class="pi pi-trash" (click)="removeEvidenceCentralItem(policySection.controls['evidenceCentralItems'], evidenceCentralItem)"></i></span>
                                <span class="pi pi-external-link" (click)="addEvidenceCentralItem(policySection.controls['evidenceCentralItems'])"></span>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </ng-container>
                <i class="pi pi-plus" style="margin-left: 50px;" (click)="addSection(policyForms[i])" pTooltip="Add Policy Section"></i>
                <textarea [(ngModel)]="comparisonText" style="width: 100%; height: 200px;" [ngModelOptions]="{standalone: true}"></textarea>
                <textarea [(ngModel)]="comparisonResult" style="width: 100%; height: 200px;" readonly [ngModelOptions]="{standalone: true}"></textarea>
                <button mat-button mat-raised-button style="margin: 10px; font-size: 1.5em;" (click)="compare(i)">Compare</button>
                <div style="text-align: center; width: 100%;">
                  <button mat-button mat-raised-button style="margin: 10px; font-size: 1.5em;" (click)="save(i)">Save</button>
                  <button mat-button mat-raised-button style="margin: 10px; font-size: 1.5em;" (click)="saveAsNew(i)">Save as New Version</button>
                  <button mat-button mat-raised-button style="margin: 10px; font-size: 1.5em;" (click)="setInactive(i)">Deactivate</button>
                  <button mat-button mat-raised-button style="margin: 10px; font-size: 1.5em;" (click)="loadPolicies()">Cancel</button>
                </div>
                <h4>Revision History</h4>
                <p-table [value]="policies[i].revisionHistories" sortField="date">
                  <ng-template pTemplate="header">
                    <tr style="white-space: nowrap;font-weight: bold">
                      <th *ngFor="let col of revisionHistoryCols">
                        {{col.header}}
                      </th>
                      <th style="width: 20em;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-revision>
                    <tr>
                      <td>
                        <span *ngIf="!revision.isEdit">{{revision.date | date:'shortDate'}}</span>
                        <span *ngIf="revision.isEdit">
                          <mat-form-field>
                            <mat-label>Date</mat-label>
                            <input matInput [(ngModel)]="revision.date" [matDatepicker]="picker1" [ngModelOptions]="{standalone: true}" />
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                          </mat-form-field>
                        </span>
                      </td>
                      <td>
                        <span *ngIf="!revision.isEdit">{{revision.description}}</span>
                        <span *ngIf="revision.isEdit">
                          <mat-form-field>
                            <mat-label>Description</mat-label>
                            <input matInput [(ngModel)]="revision.description" [ngModelOptions]="{standalone: true}" />
                          </mat-form-field>
                        </span>
                      </td>
                      <td>
                        <span *ngIf="!revision.isEdit">{{GetFullName(revision.authorId)}}</span>
                        <span *ngIf="revision.isEdit">
                          <mat-form-field>
                            <mat-label>Author</mat-label>
                            <mat-select [(ngModel)]="revision.authorId" [ngModelOptions]="{standalone: true}">
                              <mat-option *ngFor="let user of users" [value]="user.userId">{{user.fullName}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </span>
                      </td>
                      <td>
                        <i class="pi pi-pencil" *ngIf="!revision.isEdit" (click)="revision.isEdit=true"></i>
                        <i class="pi pi-save" *ngIf="revision.isEdit" (click)="revision.isEdit=false"></i>
                        <i class="pi pi-trash" (click)="removeRevision(policyForms[i].value, revision)"></i>
                      </td>
                    </tr>

                  </ng-template>
                </p-table>
                <i class="pi pi-plus" (click)="addRevision(policies[i])"></i>
                <hr />
                <h5>This entire policy maps to:</h5>
                <span *ngFor="let control of policyForms[i].controls['controlIdList'].value">{{controlItemMap[control].complianceAreaName}} - {{controlItemMap[control].complianceAreaControlId}} <i class="pi pi-trash" (click)="removeControl(policyForms[i].controls['controlIdList'], control)"></i></span>
                <span class="pi pi-external-link" (click)="addControl(policyForms[i].controls['controlIdList'])"></span>
              </form>
              <div *ngFor="let cid of item.assignedTo"><a [routerLink]="['/projects/project', cid.projectId, cid.id]">{{cid.projectName}} - {{cid.complianceAreaControlId}}</a></div>
              <div>
                <p-table *ngIf="policyForms[i].value.approvals?.length" [value]="policyForms[i].value.approvals" sortField="startDate">
                  <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of approvalCols">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-approval>
          <tr>
            <td>{{approval.startDate | date:'shortDate'}}</td>
            <td>{{getFullNameById(approval.approverId)}}</td>
            <td>
              <mat-select [(ngModel)]="approval.status"
                            [disabled]="approval.approverId != item.ownerId">
                <mat-option [value]="PolicyApprovalStatus.None"></mat-option>
                <mat-option [value]="PolicyApprovalStatus.Rejected">Rejected</mat-option>
                <mat-option [value]="PolicyApprovalStatus.Approved">Approved</mat-option>
              </mat-select>
              <span *ngIf="approval.status == PolicyApprovalStatus.Approved && approval.endDate"
                    style="margin-left:10px;">Approved on {{approval.endDate | date : "shortDate"}}</span>
            <span *ngIf="approval.status == PolicyApprovalStatus.Rejected && approval.endDate"
                  style="margin-left:10px;">Rejected on {{approval.endDate | date : "shortDate"}}</span></td>
            <td>
              <mat-form-field class="example-full-width" style="width: 100%"><input matInput style="width: 100%;"
                                                                                    [(ngModel)]="approval.note"
                                                                                    [disabled]="approval.approverId != item.ownerId"/>
              </mat-form-field>
            </td>
          </tr>

        </ng-template>
      </p-table>
    </div>
    </td>
    </tr>
    </ng-template>
    </p-table>

  </div>
    <div style="height: calc(100vh - 240px); position: relative; flex: 0 0 30%; overflow: auto;" *ngIf="displayProfile">
      <p-table [value]="inspectionProfileSets" dataKey="id">
        <ng-template pTemplate="body" let-set let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr [pRowToggler]="set" [ngStyle]="{backgroundColor: highlightedPolicySectionId && inspectionProfileSetsMap[highlightedPolicySectionId][set.inspectionProfileSetId] ? 'gray' : ''}">
            <td style="width: 10em;">
              <a>
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              </a>
            </td>
            <td>{{set.name}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-set let-rowIndex="rowIndex">
          <tr>
            <td colspan="2">
              <p-table [value]="set.inspectionProfiles" dataKey="id">
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
                  <tr [pRowToggler]="item" [ngStyle]="{backgroundColor: highlightedPolicySectionId && inspectionProfilesMap[highlightedPolicySectionId][item.id] ? 'gray' : ''}">
                    <td style="width: 10em;">
                      <a>
                        <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                      </a>
                    </td>
                    <td>{{item.name}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
                  <tr>
                    <td colspan="2">
                      <p-table [value]="item.conditions">
                        <ng-template pTemplate="body" let-condition>
                          <tr>
                            <td>{{condition.path}}</td>
                            <td>{{condition.operator}}</td>
                            <td>{{condition.value}}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    </div>
</div>
